
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { dataServiceRepository } from '@/api/common';
import NButton from '@/uikit/buttons/NButton.vue';
import NForm, { IFormModel } from '@/uikit/forms/NForm.vue';
import NModalWindow, { NModalWindowSize } from '@/uikit/modal-window/NModalWindow.vue';
import { informationLayout } from '@/pages/blocklist/forms/blocklist-form-schema';
import { SelectedItemType } from '@/pages/blocklist/forms/BlocklistForm.vue';

@Options({
  components: {
    NButton,
    NForm,
    NModalWindow
  }
})
export default class EditBlocklistForm extends Vue {
  @Prop({ type: Object, required: true })
  readonly model!: IFormModel;

  get formLayout() {
    return informationLayout;
  }

  get size() {
    return NModalWindowSize.Medium;
  }

  getIsItemFormValid(): boolean {
    const result = this.$refs.itemForm ? this.$refs.itemForm.validate() : true;
    if (!result) {
      this.$refs.itemForm.displayErrors();
    }
    return result;
  }

  saveHandler() {
    if (!this.getIsItemFormValid()) return;
    this.$emit('save');
  }

  closeHandler() {
    this.$emit('close');
  }

  mounted() {
    this.model.__uuid = this.model.uuid;
  }
}
